import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getPackageListSaga = createAction(
  "GET_PACKAGES",
  ({ payload, params }: SagaActionParams<Type.PackageDto[]>) => ({
    payload,
    url: "/api/admin/packages" + (params ? params : ""),
  })
);

export const getPackageDetailsSaga = createAction(
  "GET_PACKAGES_DETAILS",
  ({ payload, id }: SagaActionParams<Type.PackageDetailDto>) => ({
    payload,
    url: "/api/admin/packages/" + id,
  })
);
export const createPackageSaga = createAction(
  "CREATE_PACKAGES",
  ({ payload, body }: SagaActionParams<Type.PackageDto>) => ({
    payload,
    url: "/api/admin/packages",
    body,
    lang: "en-US",
  })
);
export const updatePackageSaga = createAction(
  "UPDATE_PACKAGES",
  ({ payload, id, body }: SagaActionParams<Type.PackageDto>) => ({
    payload,
    url: "/api/admin/packages/" + id,
    body,
    lang: "en-US",
  })
);
export const deletePackageSaga = createAction(
  "DELETE_PACKAGES",
  ({ payload, id }: SagaActionParams<Type.PackageDto>) => ({
    payload,
    url: "/api/admin/packages/" + id,
  })
);

const packageSaga = [
  takeLatest<any>(
    getPackageListSaga.toString(),
    (payload: SagaGenericParams<Type.PackageDto[]>) =>
      getSaga<Type.PackageDto[]>(payload)
  ),
  takeLatest<any>(
    getPackageDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.PackageDetailDto>) =>
      getSaga<Type.PackageDetailDto>(payload)
  ),
  takeLatest<any>(
    createPackageSaga.toString(),
    (payload: SagaGenericParams<Type.PackageDto>) =>
      postSaga<Type.PackageDto>(payload)
  ),
  takeLatest<any>(
    updatePackageSaga.toString(),
    (payload: SagaGenericParams<Type.PackageDto>) =>
      putSaga<Type.PackageDto>(payload)
  ),
  takeLatest<any>(
    deletePackageSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.PackageDto>(payload)
  ),
];

export default packageSaga;
